module.exports = __webpack_public_path__ + "static/media/S04_HTW_Berlin_Logo_pos_FARBIG_RGB.7083b219.jpeg";